import { Observable, take } from 'rxjs';

import { Container, Service } from '../../../symphony';
import {
	ICodeAPI, CodeApi, ICodeBitsSearchParams, ICodeBitsDetailsResponse, ILanguagesCatalogResponse,
} from '../../../api/public/code-api';

@Service()
export class SlApiService {
	private codeApi: ICodeAPI;

	constructor() {
		this.codeApi = Container.take('global', CodeApi);
	}

	public getCodeBitsDetails({
		count,
		filter,
		language,
		index,
		query,
		profileId,
	}: ICodeBitsSearchParams): Observable<ICodeBitsDetailsResponse> {
		return this.codeApi
			.getCodeBits({
				count,
				filter,
				language,
				index,
				query,
				profileId,
			})
			.pipe(take(1));
	}

	public getLanguagesCatalog(): Observable<ILanguagesCatalogResponse> {
		return this.codeApi.getLanguagesCatalog().pipe(take(1));
	}
}
